import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/pro-solid-svg-icons'
import { personFilterKey } from './entry-format'

// The person an entry or a story starts with (owner 2026-11-03: "the
// history panes show quick filter icons next to courses and items in the
// description but is missing a quick filter for the user"): their name,
// linked while they can be opened (entry-format actorView), and, where the
// timeline narrows (onPivot), the course chip's funnel beside it: "Only
// what <name> did", the actor filter Details' "Only <first name>" sets
// (user:<id>, or a super admin's login:<id>).
//
// Only a person has one (personFilterKey): never staff (EducationXR
// support), an automatic job, an integration, an unattributed change or a
// person who left. An impersonated change is the person's own in the trail
// (content files it under the actor, the impersonator is "via"), so its
// funnel narrows to the person the line names.
//
// who: actorView(actor, { sys }), as the caller already has it.
export const personOnlyText = name => `Only what ${name} did`

export const ActorName = ({ actor, who, sys = false, onPivot }) => {
  const name = who.href ? <Link className="au-who" to={who.href}>{who.text}</Link> : <b className="au-who">{who.text}</b>
  const key = onPivot ? personFilterKey(actor, { sys }) : null
  if (!key) return name
  const label = personOnlyText(who.text)
  return (
    <span className="au-who-pick">
      {name}
      <button type="button" className="au-who-only" aria-label={label} title={label} onClick={() => onPivot({ actors: [key] })}>
        <FontAwesomeIcon icon={faFilter} aria-hidden="true" />
      </button>
    </span>
  )
}
